import * as R from 'ramda'

export const getIsFetchingCompanyStatistics = R.path([
  'company',
  'processing',
  'getCompanyStatistics'
])

export const getCompanyStatistics = R.path(['company', 'companyStatistics'])

export const getIsFetchingCompanyList = R.path([
  'company',
  'processing',
  'getCompanyList'
])

export const getCompanyList = R.path(['company', 'companyList'])

export const getIsFetchingCompanyDetail = R.path([
  'company',
  'processing',
  'getCompanyDetail'
])

export const getCompanyDetail = R.path(['company', 'companyDetail'])

export const getIsCreateOrUpdatingCompany = R.path([
  'company',
  'processing',
  'createOrUpdatingCompany'
])
